





























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import TypeActors from "@/views/OWcom/DefType/TypeActors.vue";
import TypePlanning from "@/views/OWcom/DefType/TypePlanning.vue";
import TypeAction from "@/views/OWcom/DefType/TypeAction.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    TypeActors,
    TypePlanning,
    TypeAction,
    NextPrevBtn,
    Footer
  },
})
export default class DefType extends Vue {
  protected nxtprevDefType =
{
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail2.png",
    NextImage: "/thumbnail3.png",
    PrevLink: "/Definition_Communication/Partager",
    NextLink: "/Definition_Communication/Situation_Communication",
  };
}

